import React, { useContext, useRef } from 'react';
import { RootState } from 'reducer';
import { useSelector } from 'react-redux';
import { useGetPostById } from 'entity/post/postHooks';
import PostItem from 'components/post/PostItem';
import OpinionItem from 'components/opinion/OpinionItem';
import JoinGroupCarousel from 'components/group/JoinGroupCarousel';
import useScrollToComponent from 'pageContents/CommunityContent/hooks/useScrollToComponent';
import RewardNotificationCard from 'components/reward/RewardNotificationCard';
import NewUserOnboardCard from '../../NewUserOnboardCard';

import { CommunityPageContext } from '../../../../context/CommunityPageContext';

// main data consist of question and opinion
const useGetFeedListData = () => {
  let feedList: React.ReactNode[] = [];
  const { pageType } = useContext(CommunityPageContext);

  const feedIds = useSelector((state: RootState) => state.feed.idsWithType);
  const postById = useGetPostById();
  const opinionById = useSelector((state: RootState) => state.opinion.byId);
  const dailyRef = useRef(null);

  if (feedIds.length !== 0) {
    feedList = feedIds.map(feedId => {
      if (feedId.type === 'Community::Question::Entity') {
        const post = postById[feedId.id];
        if (!post) return null;
        return (
          <PostItem
            key={`${feedId.id}-post`}
            post={post}
            withComment
            enableToggle
          />
        );
      }

      if (feedId.type === 'Community::Opinion::Entity') {
        const opinion = opinionById[feedId.id];
        if (!opinion) return null;
        return <OpinionItem key={feedId.id} opinion={opinion} />;
      }

      return null;
    });
  }

  const onScrollClick = useScrollToComponent(dailyRef, 80);

  if (pageType === 'trending' || pageType === 'home') {
    feedList = [
      <RewardNotificationCard key="reward-notification" />,
      <div className="w-full" ref={dailyRef} key="daily-checkin">
        <NewUserOnboardCard
          onScrollClick={onScrollClick}
          key="new-onboard-card"
        />
      </div>,
      ...feedList.slice(0, 5),
      <JoinGroupCarousel key="group-carousel" />,
      ...feedList.slice(5),
    ];
  }

  return feedList;
};

export default useGetFeedListData;
